import { ComponentPropsWithoutRef, FC } from 'react'
import styled from 'styled-components'

const InputWrapper = styled.div`
	position: relative;
	width: 100%;
	height: 40px;
`
const Label = styled.label`
	color: #9ca3af;
	position: absolute;
	left: 0;
	top: 0.5rem;
	font-weight: 500;
	font-size: 16px;
	cursor: text;
	transition: top 200ms ease-in, left 200ms ease-in, font-size 200ms ease-in;
`
const InputStyles = styled.input`
	position: absolute;
	top: 0;
	left: 0;
	border: none;
	border-bottom: 2px solid rgba(156, 163, 175, 0.5);
	font-weight: 500;
	font-size: 16px;
	outline: none;
	width: 100%;
	height: 40px;
	background: none;
	color: #f3f4f6;
	transition: border-color 0.3s ease;
	
	&::placeholder {
		color: #9ca3af;
		font-weight: 500;
		font-size: 16px;
		line-height: 180%;
	}
	&:hover {
		border-color: rgba(99, 102, 241, 0.7);
	}
	&:focus {
		border-color: #6366f1;
		& ~ label {
			top: -0.6rem;
			font-size: 0.8rem;
			left: 0.1rem;
			color: #6366f1;
		}
	}
	&:not(:placeholder-shown)&:not(:focus) ~ label {
		top: -0.6rem;
		font-size: 0.8rem;
		left: 0.1rem;
		color: #9ca3af;
	}
`

interface ComponentProps {
	id: string
	label?: string
}
export type InputProps = ComponentProps & ComponentPropsWithoutRef<'input'>

const Input: FC<InputProps> = ({ label, value, id, onChange, ...inputAttrs }) => {
	return (
		<InputWrapper>
			<InputStyles
				id={id}
				onChange={onChange}
				value={value}
				placeholder=' '
				{...inputAttrs}
			/>
			{label && <Label htmlFor={id}>{label}</Label>}
		</InputWrapper>
	)
}

export default Input
